import { render, staticRenderFns } from "./RejectCounter.vue?vue&type=template&id=15871532&"
import script from "./RejectCounter.vue?vue&type=script&lang=ts&"
export * from "./RejectCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports